<template>
  <LoadingIndicatorComponent />
</template>

<script setup lang="ts">
import LoadingIndicatorComponent from "@/components/common/LoadingIndicatorComponent.vue";
import { useRouter, useRoute } from "vue-router";
import { useAccount } from "@/composables/account/useAccount";
import type { Account } from "../types";

const router = useRouter();
const route = useRoute();
const newQuery = {
  ...route.query,
};

const afterFetchAccount = (accountData: Account) => {
  if (accountData.companies.length > 0) {
    router.push({ path: "/dashboard", query: newQuery });
  } else {
    router.push({ path: "/signup", query: newQuery });
  }
};

useAccount(afterFetchAccount);
</script>
